<template>
  <div class="footerouter">
    <div class="mainfootertopback">
      <div class="footertop">
        <div class="toplist">
          <template v-for="(item,index) in topList">
            <div class="topitem" :key="index">
              <div :class="item.icon" class="itemicon"></div>
              <div class="itemtitle">{{item.title}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="mainfooterbottomback">
      <div class="footerbottom">
        <div class="bottomlist">
          <div class="bottomitem">
            <div class="zyjm-zuoji1 bottomicon"></div>
            <div class="iteminfo">
              <b>座机:</b>
              <span class="itemnum">{{footer.phone}}</span>
            </div>
          </div>

          <div class="bottomitem">
            <div class="zyjm-dianhua bottomicon"></div>
            <div class="iteminfo">
              <b>手机:</b>
              <span class="itemnum">{{footer.telephone}}</span>
            </div>
          </div>
          <div class="bottomitem">
            <div class="zyjm-youjian bottomicon"></div>
            <div class="iteminfo">
              <b>邮箱:</b>
              <span class="itemnum">{{footer.email}}</span>
            </div>
          </div>
          <div class="bottomitem">
            <div class="zyjm-dizhi1 bottomicon"></div>
            <div class="iteminfo">
              <b>地址:</b>
              <span class="itemnum">{{footer.address}}</span>
            </div>
          </div>
        </div>
        <div class="ooo"></div>
        <div class="bottominfo">{{footer.copyright}}</div>
        <div class="bottominfo china">
          <span>
            <img src="../../static/chinalogo.png" alt />
          </span>
          {{footer.record}}
        </div>
      </div>
    </div>

    <div class="footertkd">{{footer.title + footer.keywords+footer.description}}</div>
    <div class="toplink" v-if="footer.enterprise_email" id="toplink">
      <a :href="footer.enterprise_email" target="_blank">
        <div class="zyjm-youjian linkicon"></div>
        <div class="linkword">企业邮箱</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topList: [
        {
          icon: "zyjm-qiye",
          title: "值得信赖的企业"
        }, {
          icon: "zyjm-tuandui1",
          title: "超强实力的员工"
        }, {
          icon: "zyjm-chanpin",
          title: "优质划算的产品"
        }, {
          icon: "zyjm-gongzuojingyan",
          title: "多年雄厚的经验"
        },
      ],
      footer: ""
    }
  },
  methods: {
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.companyInfo)
        .then(res => {
          console.log(res);
          let { error_code, companyInfo } = res.data;
          if (error_code == 2001) {
            this.footer = companyInfo
          }

        })
      // this.$axios.post(this.$url.linkList)
      //   .then(res => {
      //     console.log(res);
      //     let { error_code, links } = res.data;
      //     if (error_code == 2001) {
      //       this.linkList = links
      //     }

      //   })
    }
  },
  created() {
    this.loadData();
  }
}
</script>

<style>
.toplink {
  position: fixed;
  bottom: 20%;
  right: 2%;
  width: 80px;
  height: 80px;
  background-color: #ff8735;
  border-radius: 50%;
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding-top: 10px;
  display: none;
  box-shadow: 0px 54px 22px -40px rgba(0, 0, 0, 1);
}
.toplink a {
  color: #fff !important;
}
.bottominfo img {
  width: 10px;
  height: 10px;
  margin: auto 0;
}
.footerouter {
  width: 100%;
  background-color: white;
}
.mainfootertopback {
  width: 100%;
  background-color: #f5f5f5;
}
.footertop {
  width: 100%;
  margin: 0 auto;
  /* height: 136px; */
  background-color: #f5f5f5;
  max-width: 1440px;
}
.topitem {
  text-align: center;
  width: 20%;
  /* height: 100px; */
  display: block;
  line-height: 30px !important;
}
.itemicon {
  color: #ff6900;
  font-size: 46px;
  margin-bottom: 20px;
  line-height: 30px !important;
}
.itemtitle {
  font-size: 22px;
}
.mainfooterbottomback {
  width: 100%;
  background-color: #535559;
}
.footerbottom {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  /* height: 54px; */
  background-color: #535559;
  padding: 0.2rem 0.4rem;
}
.toplist {
  display: flex;
  justify-content: space-between;
  padding: 40px 0.4rem 40px 0.4rem;
}
.bottomlist {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.bottomitem {
  display: flex;
  line-height: 0.2rem;
  height: 0.2rem;
  font-size: 0.16rem;
  justify-content: baseline;
  margin-top: 6px;
}
.bottominfo {
  font-size: 0.14rem;
  color: #b3b5b9;
  /* margin-top: 6px; */
  text-align: center;
}
.ooo {
  margin-top: 12px;
}
.iteminfo {
  /* font-size: 0.16rem; */
  color: white;
}
.bottomicon {
  color: #ff6900;
  font-size: 0.16rem;
  line-height: 0.2rem;
  margin-right: 4px;
}
.itemnum {
  color: #d0d1d1;
}
.footertkd {
  position: absolute;
  top: 0;
  color: transparent;
  font-size: 1px;
}
@media (max-width: 1920px) {
  .footertop {
    width: 100%;
  }
  .footerbottom {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .bottomlist {
    flex-direction: column;
    margin-bottom: 100px;
  }
  .bottomitem {
    font-size: 30px;
    margin-top: 40px;
    /* line-height: 40px; */
    /* margin-bottom: 100px; */
  }
  .bottomicon {
    font-size: 30px;
    line-height: 40px;
  }
  .iteminfo {
    line-height: 40px;
  }
  .bottominfo {
    text-align: left;
    font-size: 26px;
    margin-top: 10px;
  }
  .ooo {
    margin-top: 30px;
  }

  .itemtitle {
    font-size: 30px;
  }
  .toplist {
    display: flex;
    justify-content: space-between;
    padding: 40px 0.4rem 40px 0.4rem;
  }

  .footerbottom {
    padding: 0.2rem 0.4rem;
  }

  .topitem {
    width: 24%;
  }

  .bottominfo img {
    width: 20px;
    height: 20px;
    margin: auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer-item.vue